<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="header-search-wrapper" v-if="hasPermission('UserView')">
      <GlobalSearch />
    </div>

    <b-modal
      v-model="showProcessingModal"
      title="Processing..."
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
      hide-header
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="dark"
      body-text-variant="light"
    >
      <div class="process-container">
        <div v-if="reversedLogs.length === 0" class="text-center text-muted py-4">
          <div class="mb-2"><i class="fa fa-circle-o-notch fa-spin fa-2x"></i></div>
          <small>Initializing...</small>
        </div>
        <transition-group name="simple-fade" tag="div">
          <div v-for="(log, index) in reversedLogs" :key="log + index" class="d-flex align-items-start mb-2">
            <div class="icon-col mr-3 text-center pt-1">
              <i v-if="index === 0 && !isDoneLog(log)" class="fa fa-cog fa-spin text-light"></i>
              <i v-else class="fa fa-check text-muted"></i>
            </div>
            <div class="log-content">
              <span v-if="index === 0" :class="isDoneLog(log) ? 'text-success' : 'text-white'">
                {{ log }} <span v-if="!isDoneLog(log)" class="loading-dots"></span>
              </span>
              <span v-else class="text-muted">{{ log }}</span>
            </div>
          </div>
        </transition-group>
      </div>
    </b-modal>

    <b-navbar class="ml-auto">
      <b-navbar-nav>
        <Requests/>
        <HeaderDropdown/>
      </b-navbar-nav>
    </b-navbar>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderDropdown from './HeaderDropdown.vue'
import Requests from './Requests/Requests'
import GlobalSearch from './Autocomplete.vue'

export default {
  name: 'c-header',
  components: {
    HeaderDropdown,
    Requests,
    GlobalSearch
  },
  computed: {
    ...mapGetters(['isProcessing', 'processLogs']),

    reversedLogs() {
      return this.processLogs ? this.processLogs.slice().reverse() : []
    },

    showProcessingModal: {
      get() { return this.isProcessing },
      set(value) { }
    }
  },
  methods: {
    isDoneLog(log) {
      if (!log) return false;
      const lower = log.toLowerCase();
      return lower.includes('done') ||
        lower.includes('success') ||
        lower.includes('complete') ||
        lower.includes('finished');
    },
    sidebarToggle (e) { e.preventDefault(); document.body.classList.toggle('sidebar-hidden') },
    mobileSidebarToggle (e) { e.preventDefault(); document.body.classList.toggle('sidebar-mobile-show') },
  }
}
</script>

<style scoped>
.app-header.navbar {
  border-bottom: 1px solid #23282c;
  height: auto;
  min-height: 55px;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

/deep/ .navbar-brand {
  background-color: transparent !important;
  border-bottom: none !important;
  width: 155px;
  margin-right: 0;
}

.header-search-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0;
  min-width: 200px;
}

@media (max-width: 767.98px) {
  .header-search-wrapper {
    order: 10;
    flex: 0 0 100%;
    padding: 10px 15px;
    background-color: transparent !important;
    margin: 0 -10px; /* Stretch to edges */
    width: calc(100% + 20px);
  }
}

/* Navbar Nav Styles for Dark Theme */
/deep/ .nav-link {
  color: #8f9ba6 !important;
}
/deep/ .nav-link:hover {
  color: #fff !important;
}

/* Log Styles */
.process-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.icon-col {
  min-width: 24px;
  max-width: 24px;
}
.log-content {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.9rem;
  line-height: 1.5;
  word-break: break-word;
}
.simple-fade-enter-active {
  transition: opacity 0.2s ease-out;
}
.simple-fade-enter {
  opacity: 0;
}
.loading-dots::after {
  content: ' .';
  animation: dots 1.5s steps(5, end) infinite;
}
@keyframes dots {
  0%, 20% { content: ''; }
  40% { content: ' .'; }
  60% { content: ' . .'; }
  80%, 100% { content: ' . . .'; }
}
.process-container::-webkit-scrollbar {
  width: 6px;
}
.process-container::-webkit-scrollbar-track {
  background: transparent;
}
.process-container::-webkit-scrollbar-thumb {
  background: #6c757d;
  border-radius: 3px;
  opacity: 0.5;
}
</style>
